export class SnackbarDataModel {
  message: string | string[];
  icon: string;

  constructor(message: string | string[], icon: string) {
    this.message = message;
    this.icon = icon ?? icon;
  }
}
